<template>
  <div class="px-5 pb-5" style="height: 100%; overflow: auto">
    <div>
      <v-alert
        v-if="command.status === 'connect'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-swap-horizontal"
        text
        dense
      >
        <div>กำลังติดต่อ Device</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'process'"
        class="mt-2"
        outlined
        type="info"
        icon="mdi-autorenew"
        text
        dense
      >
        <div>รอ Device ดำเนินการ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'success'"
        class="mt-2"
        outlined
        type="success"
        icon="mdi-check-circle-outline"
        text
        dense
      >
        <div>สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <v-alert
        v-if="command.status === 'fail'"
        class="mt-2"
        outlined
        type="error"
        icon="mdi-close-circle-outline"
        text
        dense
      >
        <div>ไม่สำเร็จ</div>
        <div style="font-size: 11px; color: #333">
          {{ dateTimeFromNow(command.date) }}
        </div>
      </v-alert>
      <div v-if="command.status === 'success'">
        <div
          v-if="
            hardware.hardware_model &&
            ['acu01r', 'acu81r', 'cru77rf', 'vf1000r'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div v-for="item in command.responseData" :key="item.group_key">
            <div class="d-flex justify-space-between align-center mb-2">
              <p class="mb-0">
                {{ item.group_name.replace('$total', item.items.length) }}
              </p>
              <v-btn
                outlined
                small
                color="primary"
                @click="handleCheckEmployeeList"
              >
                ตรวจสอบข้อมูล
              </v-btn>
            </div>
            <v-list-item
              class="pa-0 mb-2"
              v-for="(subItem, index) in item.items"
              :key="index"
            >
              <v-list-item-content class="grey lighten-3 px-4">
                <v-list-item-title>
                  {{ subItem[0].key_name }}: {{ subItem[0].value }}
                </v-list-item-title>
                <v-list-item-subtitle
                  class="mt-1"
                  v-for="sub in subItem.slice(1)"
                  :key="sub.key_name"
                >
                  {{ sub.key_name }}:
                  <span v-if="sub.value">
                    {{ sub.value | dateTimeFormat }}
                  </span>
                  <span v-else>-</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
        <div v-else>
          <p>พนักงาน ( ทั้งหมด {{ command.responseData.length }} คน )</p>
          <v-list-item
            class="pa-0 mb-2"
            v-for="item in command.responseData"
            :key="item.employee_code"
          >
            <v-list-item-content class="grey lighten-3 pl-4">
              <v-list-item-title>
                รหัสพนักงาน: {{ item.employee_code }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <span v-if="item.last_update_utc">
                  อัพเดทล่าสุด: {{ item.last_update_utc | dateTimeFormat }}
                </span>
                <span v-else> อัพเดทล่าสุด: - </span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
      <div v-if="command.status === 'fail'">
        <div
          v-if="
            ['acu01r', 'acu81r', 'cru77rf', 'vf1000r'].includes(
              hardware.hardware_model.hardware_model_code
            )
          "
        >
          <div
            v-for="group in command.responseData"
            :key="group.group_key"
            class="mb-6"
          >
            <div>
              <p
                class="mb-2"
                style="font-weight: 600; font-size: 16px; color: #212121"
              >
                {{ group.group_name }}
              </p>
              <v-divider></v-divider>
              <v-list-item
                class="pl-0"
                two-line
                v-for="item in group.items"
                :key="group.group_key + '_' + item.key"
              >
                <v-list-item-content>
                  <v-list-item-subtitle>
                    {{ item.key_name }}
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.value || '-' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>

        <div v-else>
          <v-list-item
            two-line
            v-for="(value, key) in command.responseData"
            :key="key"
          >
            <v-list-item-content>
              <v-list-item-title>{{ key.toUpperCase() }}</v-list-item-title>
              <p style="color: #757575; margin-top: 5px; margin-bottom: 0">
                {{ value }}
              </p>
            </v-list-item-content>
          </v-list-item>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialogCheckEmployeeList" scrollable max-width="620px">
      <v-card>
        <div class="d-flex justify-space-between align-center px-4">
          <v-card-title>ตรวจสอบข้อมูลพนักงาน</v-card-title>
          <v-btn icon @click="dialogCheckEmployeeList = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text style="height: 480px">
          <v-alert
            v-if="!employeeComparison.totalDifference"
            outlined
            type="success"
            dense
            text
          >
            ไม่พบข้อมูลพนักงานที่แตกต่างกัน
          </v-alert>

          <div v-else>
            <v-alert outlined type="warning" dense text>
              พบข้อมูลแตกต่าง {{ employeeComparison.totalDifference }} รายการ
            </v-alert>

            <v-simple-table dense>
              <template #default>
                <thead>
                  <tr>
                    <th class="text-left" style="width: 60px">No</th>
                    <th class="text-left">Devices</th>
                    <th class="text-left">Systems</th>
                    <th class="text-left" style="width: 120px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in employeeComparisonRows" :key="row.key">
                    <td>{{ row.no }}</td>
                    <td>{{ row.device || '-' }}</td>
                    <td>
                      <div v-if="row.system">
                        <div>{{ row.system }}</div>
                        <div
                          class="caption"
                          :class="
                            row.systemSyncBlockReason
                              ? 'error--text'
                              : 'grey--text text--darken-1'
                          "
                        >
                          <span v-if="row.systemSyncBlockReason">
                            {{ row.systemSyncBlockReason }}
                          </span>
                          <span v-else>พร้อมส่งข้อมูล</span>
                        </div>
                      </div>
                      <span v-else>-</span>
                    </td>
                    <td class="py-2">
                      <v-btn
                        v-if="row.system && !row.systemSyncBlockReason"
                        small
                        outlined
                        color="primary"
                        class="text-capitalize"
                        :loading="sendingEmployeeCodes.includes(row.system)"
                        :disabled="sendingEmployeeCodes.includes(row.system)"
                        @click="handleEmployeeLastUpdated(row)"
                      >
                        Send Device
                      </v-btn>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'

import { mapActions } from 'vuex'

export default {
  props: {
    hardware: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dialogCheckEmployeeList: false,
      command: {
        status: null,
        date: null,
        responseData: null,
      },
      employeeComparison: {
        onlyInDevice: [],
        onlyInSystem: [],
        totalDifference: 0,
      },
      sendingEmployeeCodes: [],
      syncJobId: null,
    }
  },

  filters: {
    dateTimeFormat: function (value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
  },

  computed: {
    employeeListTranslate() {
      return this.$store.state.hardware.employeeListTranslate
    },

    employeeComparisonRows() {
      const onlyInDevice = this.employeeComparison.onlyInDevice || []
      const onlyInSystem = this.employeeComparison.onlyInSystem || []

      return [...onlyInDevice, ...onlyInSystem].map((item, index) => ({
        no: index + 1,
        key:
          item.source === 'device'
            ? `device_${item.employee_code}`
            : `system_${item.employee_code}`,
        device: item.source === 'device' ? item.employee_code : '',
        system: item.source === 'system' ? item.employee_code : '',
        systemSyncBlockReason:
          item.source === 'system' ? item.sync_block_reason : null,
        systemEmployeeUuid: item.source === 'system' ? item.employee_uuid : '',
      }))
    },
  },

  async mounted() {
    try {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        hardware_model: this.hardware.hardware_model.hardware_model_code,
        body: {
          hardware_uuid: this.hardware.hardware_uuid,
          data: null,
        },
      }

      const [_, employeeListData] = await Promise.all([
        this.fetchEmployeeListTranslate(),
        this.getEmployeeList(payload),
      ])

      this.command = {
        status: 'connect',
        date: employeeListData.create_datetime,
      }
      this.syncJob(employeeListData.sync_job_uuid)
    } catch (error) {
      if (error.response && error.response.data) {
        this.command = {
          status: 'fail',
          date: new Date(),
          responseData: {
            Type: 'Get Employees Fail',
            Message: error.response.data.message || 'Error',
          },
        }
      }
    }
  },

  methods: {
    ...mapActions({
      getEmployeeList: 'hardware/getEmployeeList',
      fetchJob: 'hardware/fetchJob',
      fetchEmployeeListTranslate: 'hardware/fetchEmployeeListTranslate',
      userAcknowledge: 'hardware/userAcknowledge',
      fetchAuthorityDeviceSummary:
        'accessAuthority/fetchAuthorityDeviceSummary',
      employeeLastUpdated: 'hardware/employeeLastUpdated',
    }),
    async handleEmployeeLastUpdated(row) {
      if (!row?.systemEmployeeUuid || !row?.system) {
        return
      }

      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.sendingEmployeeCodes = [...this.sendingEmployeeCodes, row.system]

        const response = await this.employeeLastUpdated({
          company_uuid,
          employee_uuid: row.systemEmployeeUuid,
        })

        if (response?.status === 200) {
          this.employeeComparison.onlyInSystem =
            this.employeeComparison.onlyInSystem.filter(
              (item) => item.employee_code !== row.system
            )
          this.employeeComparison.totalDifference =
            this.employeeComparison.onlyInDevice.length +
            this.employeeComparison.onlyInSystem.length
        }

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'อัพเดทข้อมูลล่าสุดของพนักงานสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.sendingEmployeeCodes = this.sendingEmployeeCodes.filter(
          (employeeCode) => employeeCode !== row.system
        )
      }
    },
    async handleCheckEmployeeList() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        await this.fetchAuthorityDeviceSummary({
          company_uuid,
          params: {
            hardware_uuid: this.hardware.hardware_uuid,
          },
        })

        const { hardwares } =
          this.$store.state.accessAuthority.authorityDeviceSummary

        const systemEmployees = this.extractSystemEmployees(hardwares)
        const deviceEmployeeCodes = this.extractDeviceEmployeeCodes(
          this.command.responseData
        )

        this.employeeComparison = this.buildEmployeeComparison(
          systemEmployees,
          deviceEmployeeCodes
        )

        this.dialogCheckEmployeeList = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },

    buildEmployeeComparison(systemEmployees, deviceEmployeeCodes) {
      const systemEmployeeCodeMap = new Set(
        systemEmployees.map((item) => item.employee_code)
      )
      const deviceEmployeeCodeMap = new Set(deviceEmployeeCodes)

      const onlyInDevice = deviceEmployeeCodes
        .filter((code) => !systemEmployeeCodeMap.has(code))
        .sort((a, b) => a.localeCompare(b))
        .map((employee_code) => ({
          employee_code,
          source: 'device',
        }))

      const onlyInSystem = systemEmployees
        .filter((item) => !deviceEmployeeCodeMap.has(item.employee_code))
        .sort((a, b) => a.employee_code.localeCompare(b.employee_code))
        .map((item) => ({
          employee_code: item.employee_code,
          employee_uuid: item.employee_uuid,
          sync_block_reason: item.sync_block_reason || null,
          source: 'system',
        }))

      return {
        onlyInDevice,
        onlyInSystem,
        totalDifference: onlyInDevice.length + onlyInSystem.length,
      }
    },

    extractSystemEmployees(hardwares) {
      if (!Array.isArray(hardwares)) {
        return []
      }

      const selectedHardware = hardwares.find(
        (item) => item.hardware_uuid === this.hardware.hardware_uuid
      )

      const employees = selectedHardware?.employees || []

      const uniqueEmployees = new Map()

      employees.forEach((item) => {
        if (
          typeof item?.employee_code !== 'string' ||
          item.employee_code.length === 0
        ) {
          return
        }

        uniqueEmployees.set(item.employee_code, {
          employee_code: item.employee_code,
          employee_uuid: item.employee_uuid,
          sync_block_reason: this.getEmployeeSyncBlockReason(item),
        })
      })

      return Array.from(uniqueEmployees.values())
    },

    getEmployeeSyncBlockReason(employee) {
      const resignDate = employee?.resign_date
      if (resignDate) {
        return 'ลาออก'
      }

      if (employee?.is_active === false || employee?.is_active === 0) {
        return 'ปิดการใช้งาน'
      }

      if (employee?.is_blacklist === true || employee?.is_blacklist === 1) {
        return 'ติด blacklist'
      }

      const startAt = employee?.time_attendance_start_time
      if (startAt) {
        const startMoment = moment(startAt)
        if (startMoment.isValid() && moment().isBefore(startMoment)) {
          return `ยังไม่อนุญาตการใช้งาน วันที่ ${startMoment.format(
            'DD/MM/YYYY HH:mm'
          )}`
        }
      }

      const endAt = employee?.time_attendance_end_time
      if (endAt) {
        const endMoment = moment(endAt)
        if (endMoment.isValid() && moment().isAfter(endMoment)) {
          return `หมดอายุการใช้งาน วันที่ ${endMoment.format(
            'DD/MM/YYYY HH:mm'
          )}`
        }
      }

      return null
    },

    extractDeviceEmployeeCodes(responseData) {
      if (!Array.isArray(responseData)) {
        return []
      }

      const employeeCodes = []

      responseData.forEach((group) => {
        if (!Array.isArray(group?.items)) {
          return
        }

        group.items.forEach((item) => {
          if (!Array.isArray(item)) {
            return
          }

          const employeeCodeData = item.find(
            (subItem) => subItem?.key === 'employee_code'
          )

          if (
            employeeCodeData &&
            typeof employeeCodeData.value === 'string' &&
            employeeCodeData.value.length > 0
          ) {
            employeeCodes.push(employeeCodeData.value)
          }
        })
      })

      return [...new Set(employeeCodes)]
    },

    syncJob(sync_job_uuid) {
      this.syncJobId = setInterval(() => {
        this.fetchJob(sync_job_uuid).then((res) => {
          this.analyzeStatus(res)
        })
      }, 1000)
    },

    clearSyncJob() {
      clearInterval(this.syncJobId)
    },

    analyzeStatus(res) {
      if (res.done_datetime && res.is_response_success) {
        if (
          res.command === 'get_employee_list' &&
          ['acu01r', 'acu81r', 'cru77rf', 'vf1000r'].includes(
            res.hardware?.hardware_model?.hardware_model_code
          )
        ) {
          const data = res.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.employeeListTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) =>
                Object.entries(subItem).map(([key, obj]) => ({
                  key,
                  key_name:
                    this.employeeListTranslate?.keys[key]?.th ||
                    key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: obj.value,
                  type: obj.type,
                }))
              ),
            }
          })

          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData: data,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
        } else {
          let responseData = []
          if (res.response_json.employee.data.length > 0) {
            responseData = res.response_json.employee.data.sort((a, b) =>
              a.employee_code.localeCompare(b.employee_code)
            )
          }
          this.command = {
            status: 'success',
            date: res.done_datetime,
            responseData,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
        }
      } else if (res.done_datetime && !res.is_response_success) {
        if (
          ['get_employee_list'].includes(res.command) &&
          ['acu01r', 'acu81r', 'cru77rf', 'vf1000r'].includes(
            res.hardware?.hardware_model?.hardware_model_code
          )
        ) {
          const data = res.response_json.map((item) => {
            return {
              group_key: item.group_key,
              group_name:
                this.employeeListTranslate?.groups[item.group_key]?.th ||
                item.group_key
                  .replace(/_/g, ' ')
                  .replace(/\b\w/g, (char) => char.toUpperCase()),
              items: item.items.map((subItem) =>
                Object.entries(subItem).map(([key, obj]) => ({
                  key,
                  key_name:
                    this.employeeListTranslate?.keys[key]?.th ||
                    key
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase()),
                  value: obj.value,
                  type: obj.type,
                }))
              ),
            }
          })

          this.command = {
            status: 'fail',
            date: res.done_datetime,
            responseData: data,
          }
          this.clearSyncJob()
          // User Acknowledge
          if (res.user_acknowledge_datetime === null) {
            this.acknowledge(res.sync_job_uuid)
          }
          return
        }

        this.command = {
          status: 'fail',
          date: res.done_datetime,
          responseData: {
            Type: res.response_json?.error_type || 'Error Type',
            Message: res.response_json?.error_message || 'Error Message',
          },
        }
        this.clearSyncJob()
        // User Acknowledge
        if (res.user_acknowledge_datetime === null) {
          this.acknowledge(res.sync_job_uuid)
        }
      } else if (res.notice_datetime) {
        this.command = {
          status: 'process',
          date: res.notice_datetime,
        }
      }
    },

    acknowledge(sync_job_uuid) {
      this.userAcknowledge(sync_job_uuid).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },

    dateTimeFromNow(value) {
      return moment.utc(value, 'YYYY-MM-DD HH:mm:ss').locale('th').fromNow()
    },
  },

  beforeDestroy() {
    this.clearSyncJob()
  },
}
</script>
